export default __webpack_public_path__ + "assets/a18518392dae152a09732cd31cfb7e36.png";